
import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}/credit-segment`; // Replace with your actual API URL


// Fetch all credit segment codes
export const fetchCreditSegmentCodes = async () => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(API_URL, { headers: customHeaders });
  return response.data;
};

export const fetchCreditSegmentCodeTable = async (page: number, limit: number) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};
// Fetch a credit segment code by ID
export const fetchCreditSegmentCodeById = async (id: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

// Create a new credit segment code
export const addCreditSegmentCode = async (newCode: { key: string; value: string }) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.post(API_URL, newCode, { headers: customHeaders });
  return response.data;
};

// Edit an existing credit segment code
export const updateCreditSegmentCode = async (id: string, updatedCode: { key: string; value: string }) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.put(`${API_URL}/${id}`, updatedCode, { headers: customHeaders });
  return response.data;
};

// Delete a credit segment code
export const removeCreditSegmentCode = async (id: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.delete(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};
